import { Grid, InputLabel, MenuItem, TextField } from "@material-ui/core";
import useStyles from "../styles";
export const Select = ({
  label,
  name,
  onChange,
  required,
  disabled,
  optionsProps,
  defaultValue,
}) => {
  const { options, value = "value", text = "label" } = optionsProps;
  const classes = useStyles();
  return (
    <Grid item xs={3}>
      <InputLabel className={classes.label}>
        {label + (required ? " (*)" : "")}
      </InputLabel>
      <TextField
        className={classes.input}
        name={name}
        variant="outlined"
        size="small"
        select
        fullWidth
        disabled={disabled}
        onChange={onChange}
        defaultValue={defaultValue}
      >
        {options.map((option, index) => {
          return (
            <MenuItem key={index} value={option[value]}>
              {option[text]}
            </MenuItem>
          );
        })}
      </TextField>
    </Grid>
  );
};
